// Vokshus kakkort v2 (4/10 2026): helskärm, lika Avvis/Godta, val per syfte, gamla ja frågas om.
// Markup och stil: snippets/vokshus-cookie-banner.liquid. Spärren: snippets/vokshus-privacy.liquid.
//
// Sanningen är Shopifys samtycke (_tracking_consent). Versionen sparas I SAMMA KAKA via
// setTrackingConsent({ metafields }) och läses med getTrackingConsentMetafield (Shopifys Customer
// Privacy API). localStorage 'vk-consent-v2' är en spegel: den räknas bara när metafältet saknas OCH
// spegeln stämmer med Shopifys nuvarande val. 'vk-consent-reask' är reserv för markeringen
// «gammalt ja, redan tillbakadraget, ännu obesvarat».
//
// Lägen vid sidstart (efter Shopifys API, högst 10 s):
//   ok        v = '2', båda syftena besvarade, högst 12 mån gammalt -> inget kort, spärren släpper det valda
//   resendno  v = '2' med ja, men vårt lokala nej gick aldrig fram  -> nejet skickas igen tyst, inget kort
//   reask     ja utan v = '2' (gammalt ja) eller v2-ja äldre än 12 mån -> dras tillbaka, sedan kortet
//   ask       obesvarat, redan tillbakadraget eller v2-nej äldre än 12 mån -> kortet
//   oldno     gammalt nej (no/no utan v)                          -> står kvar, inget kort
//   syncno    lokalt gammalt nej, Shopify tomt                     -> nejet skickas tyst, inget kort
//   inget API inom 10 s                                            -> inget kort, ingen spårning, ingen låsning
// Ett obekräftat ja sparas aldrig. Ett nej gäller direkt. Inget kryss och ingen Lukk (Elias 4/10 ~17:55):
// vid första frågan gör Esc ingenting; i «Velg selv» går Esc tillbaka; ett kort som kunden själv öppnat
// igen via fotlänken stänger Esc utan ändring. Ett JS-fel får aldrig lämna helskärmen öppen.
(() => {
  const VERSION = '2';
  const MF_V = 'vk_consent_v';
  const MF_AT = 'vk_consent_at';
  const LOCAL_KEY = 'vk-consent-v2';
  const REASK_KEY = 'vk-consent-reask';
  const OLD_KEY = 'vk-cookies-v1';
  const RELOAD_KEY = 'vk-consent-reload';
  const RESHOW = 'a[href$="#shopifyReshowConsentBanner"], [data-vk-consent-open]';
  // Hur länge ett val gäller (sätts i vokshus-privacy.liquid, annars 12 månader).
  const MAX_AGE = typeof window.__vkConsentMaxAge === 'number' && window.__vkConsentMaxAge > 0 ? window.__vkConsentMaxAge : 31536e6;
  const API_WAIT_MS = 10000;  // långsam 4G gav API:t efter 4,8 s (mätt 4/10)
  const CLICK_LOCK_MS = 600;  // tryck som redan var på väg när kortet dök upp räknas inte som val
  // Kakor och lagring som raderas när syftet inte är tillåtet. Klaviyos __kla_id och Shopifys egna rörs aldrig.
  const COOKIES_A = /^(_ga|_ga_.+|_gid|_clck|_clsk)$/;
  const COOKIES_M = /^(_fbc|_fbp|_ttp|_uetvid|_uetsid|_uetmsclkid|_gcl_.+|_wtp|_pin_unauth|_epik|_derived_epik|_tt_enable_cookie|_scid)$/;
  const STORE_A = ['vk-external-id'];
  const STORE_M = ['vk-attr-v1', 'wt:attributes', 'taboola global:tblci', 'vk-subscriber-email'];

  const root = document.querySelector('[data-vk-consent]');
  if (!root) return;
  const card = root.querySelector('.vk-consent__card');
  const layer1 = root.querySelector('[data-vk-consent-layer="1"]');
  const layer2 = root.querySelector('[data-vk-consent-layer="2"]');
  if (!card || !layer1 || !layer2) return; // blandat läge under release: inget kort, ingen spårning
  const boxA = root.querySelector('[data-vk-consent-purpose="analytics"]');
  const boxM = root.querySelector('[data-vk-consent-purpose="marketing"]');
  const customizeBtn = root.querySelector('[data-vk-consent-customize]');
  const live = document.querySelector('[data-vk-consent-live]');
  const quiet = root.hasAttribute('data-vk-consent-quiet') || !!(window.Shopify && window.Shopify.designMode);
  const html = document.documentElement;

  // ---- lagring som aldrig kastar ----
  function lsGet(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }
  function lsRemove(k) { try { window.localStorage.removeItem(k); } catch (e) {} }

  // ---- Shopifys egen banner hålls dold (som förut) ----
  const SHOPIFY_BANNER_SEL = 'shopify-privacy-banner,.shopify-privacy-banner,#shopify-pc__banner,[data-shopify-privacy-banner],#shopify-cookies-info';
  function hideShopifyNative() {
    try {
      Array.prototype.forEach.call(document.querySelectorAll(SHOPIFY_BANNER_SEL), (el) => {
        el.style.setProperty('display', 'none', 'important');
      });
    } catch (e) {}
  }
  hideShopifyNative();
  try {
    const mo = new MutationObserver(hideShopifyNative);
    mo.observe(html, { childList: true, subtree: true });
    setTimeout(() => mo.disconnect(), 8000);
  } catch (e) {}

  // ---- Shopifys API ----
  function privacyApi() {
    const cp = window.Shopify && window.Shopify.customerPrivacy;
    return cp && typeof cp.setTrackingConsent === 'function' && typeof cp.currentVisitorConsent === 'function' ? cp : null;
  }
  function primePrivacyApi() {
    if (privacyApi()) return;
    try {
      if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {});
      }
    } catch (e) {}
  }
  // cb(cp) när API:t finns, cb(null) om det inte kommit inom maxMs.
  function withPrivacyApi(cb, maxMs) {
    const cp0 = privacyApi();
    if (cp0) { cb(cp0); return; }
    primePrivacyApi();
    const start = Date.now();
    const timer = setInterval(() => {
      const cp = privacyApi();
      if (cp) { clearInterval(timer); cb(cp); }
      else if (Date.now() - start > maxMs) { clearInterval(timer); cb(null); }
    }, 100);
  }

  // ---- lokal spegel och läge ----
  function readLocal() {
    try { const r = JSON.parse(lsGet(LOCAL_KEY) || 'null'); return r && r.v === VERSION ? r : null; } catch (e) { return null; }
  }
  function writeLocal(rec) { lsSet(LOCAL_KEY, JSON.stringify(rec)); }
  function oldDeclined() { return lsGet(OLD_KEY) === 'declined'; }
  function localReask() { return lsGet(REASK_KEY) === '1'; }

  function readState(cp) {
    let c = {};
    try { c = cp.currentVisitorConsent() || {}; } catch (e) {}
    let v = '';
    let at = '';
    if (typeof cp.getTrackingConsentMetafield === 'function') {
      try { v = cp.getTrackingConsentMetafield(MF_V) || ''; at = cp.getTrackingConsentMetafield(MF_AT) || ''; } catch (e) {}
    }
    if (!v) {
      // Reserv: sparar Shopify inte metafältet räknas spegeln, men bara om den stämmer med Shopifys val.
      // Utan detta skulle varje sida tolka det nya ja:t som gammalt och fråga om i all evighet.
      const l = readLocal();
      if (l && l.a === (c.analytics === 'yes') && l.m === (c.marketing === 'yes')) { v = l.v; at = l.at || ''; }
    }
    return { a: c.analytics || '', m: c.marketing || '', v: v, at: at };
  }
  // Date.parse bara på vår egen ISO-tid med Z (toISOString).
  function stale(at) {
    const t = typeof at === 'string' && at ? Date.parse(at) : NaN;
    return isFinite(t) && Date.now() - t > MAX_AGE;
  }
  function isLive(s) { return !!s && s.v === VERSION && !stale(s.at); }
  const answered = (x) => x === 'yes' || x === 'no';
  function decide(s) {
    const anyYes = s.a === 'yes' || s.m === 'yes';
    if (s.v === VERSION && answered(s.a) && answered(s.m)) {
      if (oldDeclined() && anyYes) return 'resendno';
      if (stale(s.at)) return anyYes ? 'reask' : 'ask';
      return 'ok';
    }
    // Ett ja utan giltig version dras alltid tillbaka, även om reask-flaggan redan finns
    // (ett tidigare tillbakadragande kan ha fallerat, granskningen 4/10).
    if (anyYes) return 'reask';
    if (s.v === 'reask' || localReask()) return 'ask';
    if (s.a === 'no' && s.m === 'no') return 'oldno';
    if (oldDeclined()) return 'syncno';
    return 'ask';
  }

  // ---- seriell kö: två setTrackingConsent får aldrig korsa varandra ----
  let queue = Promise.resolve(true);
  function send(cp, consent) {
    queue = queue.then(() => new Promise((resolve) => {
      let done = false;
      const fin = (ok) => { if (!done) { done = true; resolve(ok); } };
      try { cp.setTrackingConsent(consent, (err) => fin(!err)); } catch (e) { fin(false); }
      setTimeout(() => fin(false), 12000);
    }));
    return queue;
  }
  function matches(cp, a, m) {
    try {
      const c = cp.currentVisitorConsent();
      return c.analytics === (a ? 'yes' : 'no') && c.marketing === (m ? 'yes' : 'no');
    } catch (e) { return false; }
  }
  function notify() { try { document.dispatchEvent(new Event('vk:privacy-change')); } catch (e) {} }

  // ---- radera det som inte är tillåtet ----
  function dropCookie(name) {
    const host = window.location.hostname;
    const base = host.replace(/^www\./, '');
    const gone = '=; Max-Age=0; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
    [gone, gone + '; domain=' + host, gone + '; domain=.' + base].forEach((c) => {
      try { document.cookie = name + c; } catch (e) {}
    });
  }
  function enforce(aOk, mOk) {
    if (aOk && mOk) return;
    try {
      const names = String(document.cookie || '').split(';').map((p) => p.split('=')[0].trim()).filter(Boolean);
      names.forEach((n) => {
        if ((!aOk && COOKIES_A.test(n)) || (!mOk && COOKIES_M.test(n))) dropCookie(n);
      });
    } catch (e) {}
    (aOk ? [] : STORE_A).concat(mOk ? [] : STORE_M).forEach(lsRemove);
  }
  // Efter ett återkallat ja: ladda om en gång, så att GA4, Clarity och appixlar som redan kör stoppas.
  // Efter omladdningen är läget 'ok' eller 'resendno', aldrig kort, så det kan inte bli en slinga.
  function reloadOnce() {
    try {
      const last = Number(window.sessionStorage.getItem(RELOAD_KEY) || 0);
      if (Date.now() - last < 15000) return;
      window.sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
    } catch (e) {}
    setTimeout(() => { try { window.location.reload(); } catch (e) {} }, 300);
  }

  // ---- val ----
  let prev = { a: false, m: false };
  function choose(a, m) {
    const at = new Date().toISOString();
    const lost = (prev.a && !a) || (prev.m && !m);
    window.__vkConsentPending = true;
    window.__vkConsentChoice = null;
    if (!a && !m) {
      // Ett nej gäller direkt, även om Shopify inte svarar.
      writeLocal({ v: VERSION, a: false, m: false, at: at });
      lsSet(OLD_KEY, 'declined');
    }
    if (typeof window.__vkUpdateConsent === 'function') { try { window.__vkUpdateConsent(false); } catch (e) {} }
    notify();
    close();
    let finished = false;
    function finish(ok) {
      if (finished) return;
      finished = true;
      window.__vkConsentPending = false;
      if (ok) {
        writeLocal({ v: VERSION, a: a, m: m, at: at });
        lsRemove(REASK_KEY);
        if (a || m) lsRemove(OLD_KEY);
        window.__vkConsentChoice = a || m ? 'chosen' : 'declined';
        say();
      } else {
        // Obekräftat ja sparas aldrig; kortet öppnas igen först vid nästa sidvisning.
        if (a || m) lsRemove(LOCAL_KEY);
        window.__vkConsentChoice = a || m ? undefined : 'declined';
      }
      enforce(ok && a, ok && m);
      if (typeof window.__vkLoadAnalytics === 'function') { try { window.__vkLoadAnalytics(); } catch (e) {} }
      notify();
      if (lost) reloadOnce();
    }
    withPrivacyApi((cp) => {
      if (!cp) { finish(false); return; }
      send(cp, {
        analytics: a, marketing: m, preferences: false,
        metafields: [{ key: MF_V, value: VERSION }, { key: MF_AT, value: at }]
      }).then((ok) => finish(ok && matches(cp, a, m)));
    }, API_WAIT_MS);
  }
  function revokeOld(cp) {
    window.__vkConsentPending = true;
    lsSet(REASK_KEY, '1'); // reserv om Shopify inte sparar metafältet
    notify();
    send(cp, { analytics: false, marketing: false, preferences: false, metafields: [{ key: MF_V, value: 'reask' }] })
      .then(() => { window.__vkConsentPending = false; notify(); });
  }
  function say() {
    if (!live) return;
    live.textContent = '';
    setTimeout(() => { live.textContent = live.getAttribute('data-saved') || ''; }, 50);
  }

  // ---- öppna, stänga, lager ----
  let forced = false;
  let openedAt = 0;
  let lastFocus = null;
  let inerted = [];
  function setInert(on) {
    if (on) {
      inerted = [];
      const hasInert = 'inert' in HTMLElement.prototype;
      Array.prototype.forEach.call(document.body.children, (el) => {
        if (el === root || el === live || el.tagName === 'SCRIPT' || el.tagName === 'STYLE' || el.tagName === 'LINK') return;
        if (hasInert) { if (!el.inert) { el.inert = true; inerted.push([el, 'inert']); } }
        else if (el.getAttribute('aria-hidden') !== 'true') { el.setAttribute('aria-hidden', 'true'); inerted.push([el, 'aria']); }
      });
    } else {
      inerted.forEach((p) => { if (p[1] === 'inert') p[0].inert = false; else p[0].removeAttribute('aria-hidden'); });
      inerted = [];
    }
  }
  function focusEl(el) {
    if (!el) return;
    try { el.focus({ preventScroll: true }); } catch (e) { try { el.focus(); } catch (e2) {} }
  }
  function markScroll() {
    card.classList.toggle('vk-consent__card--scroll', card.scrollHeight > card.clientHeight + 1);
  }
  function showLayer(n) {
    layer1.hidden = n !== 1;
    layer2.hidden = n !== 2;
    card.setAttribute('aria-labelledby', n === 1 ? 'vk-consent-title' : 'vk-consent-title-2');
    if (n === 1) card.setAttribute('aria-describedby', 'vk-consent-text'); else card.removeAttribute('aria-describedby');
    if (customizeBtn) customizeBtn.setAttribute('aria-expanded', n === 2 ? 'true' : 'false');
    card.scrollTop = 0;
    markScroll();
    focusEl(root.querySelector(n === 1 ? '#vk-consent-title' : '#vk-consent-title-2'));
  }

  // En öppen modal <dialog> (korglådan, sökrutan, snabbköpet) ligger i webbläsarens översta lager,
  // ovanför kortet oavsett z-index. Kortet väntar därför tills den stängts (granskningen 4/10).
  function modalDialog() {
    try { return document.querySelector('dialog:modal'); } catch (e) {
      try { return document.querySelector('dialog[open]'); } catch (e2) { return null; }
    }
  }
  function whenNoModal(fn) {
    const dlg = modalDialog();
    if (!dlg) { fn(); return; }
    let done = false;
    let timer = 0;
    const next = () => {
      if (done) return;
      done = true;
      clearInterval(timer);
      try { dlg.removeEventListener('close', next); } catch (e) {}
      setTimeout(() => whenNoModal(fn), 60);
    };
    try { dlg.addEventListener('close', next); } catch (e) {}
    // Reserv: dialogen kan tas bort ur sidan utan close-händelse.
    timer = setInterval(() => { if (!dlg.open || !document.documentElement.contains(dlg)) next(); }, 500);
  }
  // Öppnas en modal dialog medan kortet syns (t.ex. korglådan efter ett tryck som redan var på väg),
  // läggs kortet undan och kommer tillbaka när dialogen stängts.
  let dialogWatch = null;
  function watchDialogs() {
    if (dialogWatch || typeof MutationObserver !== 'function') return;
    try {
      dialogWatch = new MutationObserver(() => {
        if (root.hidden) return;
        const dlg = modalDialog();
        if (!dlg || root.contains(dlg)) return;
        const wasForced = forced;
        suspend();
        whenNoModal(() => { safeOpen(wasForced); });
      });
      dialogWatch.observe(html, { attributes: true, attributeFilter: ['open'], subtree: true });
    } catch (e) { dialogWatch = null; }
  }
  function suspend() {
    root.hidden = true;
    html.classList.remove('vk-cookies-open');
    html.classList.remove('vk-consent-modal');
    setInert(false);
  }

  function open(isForced) {
    if (!root.hidden) return; // redan öppet
    forced = !!isForced;
    openedAt = Date.now();
    lastFocus = document.activeElement;
    // Brytarna visar nuvarande giltiga val; gamla ja och val äldre än 12 månader räknas inte.
    const cp = privacyApi();
    const s = cp ? readState(cp) : null;
    const valid = isLive(s);
    prev = { a: valid && s.a === 'yes', m: valid && s.m === 'yes' };
    if (boxA) boxA.checked = prev.a;
    if (boxM) boxM.checked = prev.m;
    root.hidden = false;
    html.classList.add('vk-cookies-open'); // vokshus-sticky-atc döljer köpraden
    html.classList.add('vk-consent-modal');
    setInert(true);
    showLayer(1);
    watchDialogs();
  }
  // Öppna utan risk: ett fel mitt i öppningen får aldrig lämna sidan låst. Ger true om kortet syns.
  function safeOpen(isForced) {
    try { open(isForced); return !root.hidden; } catch (e) {
      try { close(); } catch (e2) {}
      return false;
    }
  }
  function close() {
    if (root.hidden) return;
    root.hidden = true;
    html.classList.remove('vk-cookies-open');
    html.classList.remove('vk-consent-modal');
    setInert(false);
    const main = document.querySelector('#MainContent');
    const back = lastFocus && lastFocus !== document.body && document.documentElement.contains(lastFocus) ? lastFocus : main;
    if (back && back === main && !back.hasAttribute('tabindex')) {
      back.setAttribute('tabindex', '-1');
      back.addEventListener('blur', () => back.removeAttribute('tabindex'), { once: true });
    }
    focusEl(back);
  }

  // ---- knappar (alltid inslagna: ett fel får aldrig lämna helskärmen öppen) ----
  function safe(fn) {
    return (event) => {
      try { fn(event); } catch (e) { try { close(); } catch (e2) {} }
    };
  }
  root.addEventListener('click', safe((event) => {
    const t = event.target;
    if (!t || !t.closest) return;
    const btn = t.closest('[data-vk-consent-accept],[data-vk-consent-reject],[data-vk-consent-customize],[data-vk-consent-save],[data-vk-consent-back]');
    if (!btn) return;
    // Tidsspärr: kortet kom av sig självt för mindre än 600 ms sedan. Ett tryck som var på väg till
    // sidan under (t.ex. «Legg i handlekurv») får aldrig bli ett val.
    if (forced && Date.now() - openedAt < CLICK_LOCK_MS) { event.preventDefault(); return; }
    if (btn.hasAttribute('data-vk-consent-accept')) choose(true, true);
    else if (btn.hasAttribute('data-vk-consent-reject')) choose(false, false);
    else if (btn.hasAttribute('data-vk-consent-save')) choose(!!(boxA && boxA.checked), !!(boxM && boxM.checked));
    else if (btn.hasAttribute('data-vk-consent-customize')) showLayer(2);
    else if (btn.hasAttribute('data-vk-consent-back')) showLayer(1);
  }));

  // ---- tangentbord: fokusfälla, Esc ----
  function focusables() {
    const layer = layer2.hidden ? layer1 : layer2;
    const list = [];
    Array.prototype.forEach.call(layer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled])'), (el) => {
      if (el.offsetWidth || el.offsetHeight || el.getClientRects().length) list.push(el);
    });
    return list;
  }
  root.addEventListener('keydown', safe((e) => {
    const key = e.key || '';
    if (key === 'Escape' || key === 'Esc' || e.keyCode === 27) {
      e.preventDefault();
      if (!layer2.hidden) showLayer(1);
      else if (!forced) close();
      // Första frågan: Esc gör ingenting (Elias 4/10, alertdialog).
      return;
    }
    if (key === 'Tab' || e.keyCode === 9) {
      const f = focusables();
      if (!f.length) return;
      const first = f[0];
      const last = f[f.length - 1];
      const active = document.activeElement;
      const onTitle = active && active.classList && active.classList.contains('vk-consent__title');
      if (e.shiftKey && (active === first || onTitle || !card.contains(active))) { e.preventDefault(); focusEl(last); }
      else if (!e.shiftKey && (active === last || !card.contains(active))) { e.preventDefault(); focusEl(first); }
    }
  }));
  // Om fokus ändå hamnar utanför (skärmläsare, programmatiskt) flyttas det tillbaka.
  document.addEventListener('focusin', (e) => {
    try {
      if (!root.hidden && !root.contains(e.target)) focusEl(root.querySelector(layer2.hidden ? '#vk-consent-title' : '#vk-consent-title-2'));
    } catch (err) {}
  }, true);
  window.addEventListener('resize', () => { try { if (!root.hidden) markScroll(); } catch (e) {} });

  // ---- fotlänken: Shopifys egen länk öppnar VÅRT kort (fångas före Shopifys lyssnare) ----
  // Shopifys lyssnare stoppas bara om vårt kort faktiskt öppnades. Vid fel tas vk-consent-ready bort,
  // så att Shopifys egen dialog visas och kunden ändå kan ändra eller återkalla sitt val.
  window.addEventListener('click', (e) => {
    const t = e.target;
    if (!t || !t.closest || !t.closest(RESHOW)) return;
    const opened = safeOpen(false);
    if (opened) {
      e.preventDefault();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      e.stopPropagation();
    } else {
      html.classList.remove('vk-consent-ready');
    }
  }, true);
  function openFromHash() {
    let hash = '';
    try { hash = window.location.hash; } catch (e) {}
    if (hash === '#shopifyReshowConsentBanner' && !safeOpen(false)) html.classList.remove('vk-consent-ready');
  }
  window.addEventListener('hashchange', openFromHash);
  // Först nu, när fotlänken säkert öppnar vårt kort, får CSS:en dölja Shopifys inställningsdialog.
  html.classList.add('vk-consent-ready');

  // ---- start ----
  function init() {
    withPrivacyApi((cp) => {
      try { document.dispatchEvent(new Event('vk:privacy-ready')); } catch (e) {}
      if (!cp) return; // inget API: inget kort, ingen spårning, sajten låses inte
      try {
        const s = readState(cp);
        const d = decide(s);
        if (d === 'ok') {
          writeLocal({ v: VERSION, a: s.a === 'yes', m: s.m === 'yes', at: s.at });
          enforce(s.a === 'yes', s.m === 'yes');
          openFromHash();
          return;
        }
        enforce(false, false);
        if (d === 'resendno') {
          // Vårt nej gick inte fram förra gången: skicka det igen, tyst, med samma tid.
          const l = readLocal();
          send(cp, {
            analytics: false, marketing: false, preferences: false,
            metafields: [{ key: MF_V, value: VERSION }, { key: MF_AT, value: (l && l.at) || new Date().toISOString() }]
          }).then(notify);
          openFromHash();
          return;
        }
        if (d === 'oldno') { openFromHash(); return; }
        if (d === 'syncno') { send(cp, { analytics: false, marketing: false, preferences: false }); openFromHash(); return; }
        if (d === 'reask') revokeOld(cp); // även på tysta sidor
        if (quiet) { openFromHash(); return; }
        whenNoModal(() => { safeOpen(true); });
      } catch (e) {
        try { close(); } catch (e2) {}
      }
    }, API_WAIT_MS);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
